module.exports = __webpack_public_path__ + "img/diners-square.3115e01d.svg";